import { useState } from 'react'

import { useGenerateVenueReferralCodeMutation } from '../../../../../graphql'

export function useFriendReferralGenerateCode() {
  const [hasError, setHasError] = useState(false)
  const [generatedReferral, setGeneratedReferral] = useState<{
    code: string | null
    rewardDescription: string | null
    shareText: string | null
  } | null>(null)
  const [generateReferralCode, { loading: isGenerating }] = useGenerateVenueReferralCodeMutation()

  const generateCodeIfNeeded = async (companyId: string): Promise<boolean> => {
    const result = await generateReferralCode({ variables: { companyId } })
    if (!result.data?.generateReferralCode) {
      setHasError(true)
      return false
    }
    setGeneratedReferral({
      code: result.data.generateReferralCode.code,
      rewardDescription: result.data.generateReferralCode.rewardDescription,
      shareText: result.data.generateReferralCode.shareText,
    })
    return true
  }

  return {
    code: generatedReferral?.code,
    rewardDescription: generatedReferral?.rewardDescription,
    shareText: generatedReferral?.shareText,
    hasError,
    onErrorClose: () => setHasError(false),
    isGenerating,
    generateCodeIfNeeded,
  }
}
